import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "copyButton", "copySource"]

  connect() {
    this.show(this.defaultKey())
  }

  switch(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.exampleKey)
  }

  show(key) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.exampleKey === key
      tab.classList.toggle("bg-dsop-green-primary", active)
      tab.classList.toggle("text-white", active)
      tab.classList.toggle("border-slate-300", !active)
      tab.classList.toggle("text-slate-700", !active)
      tab.setAttribute("aria-pressed", active ? "true" : "false")
    })

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.exampleKey !== key)
    })
  }

  async copy(event) {
    const button = event.currentTarget
    const key = button.dataset.exampleKey
    const source = this.copySourceTargets.find((node) => node.dataset.exampleKey === key)
    if (!source) return

    const text = source.textContent

    try {
      await navigator.clipboard.writeText(text)
      this.flashCopied(button)
    } catch (_error) {
      this.fallbackCopy(text)
      this.flashCopied(button)
    }
  }

  defaultKey() {
    return this.tabTargets[0]?.dataset.exampleKey
  }

  flashCopied(button) {
    const original = button.textContent
    button.textContent = "Copiado!"
    button.classList.add("bg-dsop-green-action", "text-white", "border-dsop-green-action")
    setTimeout(() => {
      button.textContent = original
      button.classList.remove("bg-dsop-green-action", "text-white", "border-dsop-green-action")
    }, 1200)
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }
}
